(function ($) {
    function initMap() {
        var lat=$("#section-mapa").data("lat");
        var lng=$("#section-mapa").data("lng");
        var address=$("#section-mapa").data("address");
        var titular=$("#section-mapa").data("titular");
        var texto=$("#section-mapa").data("texto");
        console.log("titular>>>>>>"+titular);
        console.log("texto>>>>>>"+texto);

        //var location = new google.maps.LatLng(40.462533, -3.616254);
        var location = new google.maps.LatLng( lat, lng);
        var mapCanvas = document.getElementById('map');
        var mapOptions = {
            center: location,
            zoom: 15,
            panControl: false,
            scrollwheel: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        }
        var map = new google.maps.Map(mapCanvas, mapOptions);

        var markerImage = '/wp-content/themes/aslan/dist/images/marker.png';

        var marker = new google.maps.Marker({
            position: location,
            map: map,
            icon: markerImage
        });

        var contentString = '<div class="info-window">' +
                '<div class="info-content">' +
                '<h3>' + titular + '</h3>' +
                '<p>' + texto + '</p>' +
                '</div>' +
                '</div>';

        var infowindow = new google.maps.InfoWindow({
            content: contentString,
            maxWidth: 400
        });

        marker.addListener('click', function () {
            infowindow.open(map, marker);
        });

        var styles = [{"featureType": "landscape", "stylers": [{"saturation": -100}, {"lightness": 65}, {"visibility": "on"}]}, {"featureType": "poi", "stylers": [{"saturation": -100}, {"lightness": 51}, {"visibility": "simplified"}]}, {"featureType": "road.highway", "stylers": [{"saturation": -100}, {"visibility": "simplified"}]}, {"featureType": "road.arterial", "stylers": [{"saturation": -100}, {"lightness": 30}, {"visibility": "on"}]}, {"featureType": "road.local", "stylers": [{"saturation": -100}, {"lightness": 40}, {"visibility": "on"}]}, {"featureType": "transit", "stylers": [{"saturation": -100}, {"visibility": "simplified"}]}, {"featureType": "administrative.province", "stylers": [{"visibility": "off"}]}, {"featureType": "water", "elementType": "labels", "stylers": [{"visibility": "on"}, {"lightness": -25}, {"saturation": -100}]}, {"featureType": "water", "elementType": "geometry", "stylers": [{"hue": "#ffff00"}, {"lightness": -25}, {"saturation": -97}]}];

        map.set('styles', styles);
    }
    if($('#section-mapa').length){
        console.log("init map");
        google.maps.event.addDomListener(window, 'load', initMap);
    }
})(window.jQuery);
